import OrdersOpen from "@/views/admin/order/OrdersOpen";

export default {
  path: "orders-open/list",
  name: "ordersOpen",
  component: OrdersOpen,
  meta: {
    requiresAuth: true
  }
};
